module.exports = __webpack_public_path__ + "static/media/logo.1190672e.svg";